import { render, staticRenderFns } from "./JsonFormat.vue?vue&type=template&id=5fec0868&scoped=true&"
import script from "./JsonFormat.vue?vue&type=script&lang=ts&"
export * from "./JsonFormat.vue?vue&type=script&lang=ts&"
import style0 from "./JsonFormat.vue?vue&type=style&index=0&id=5fec0868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec0868",
  null
  
)

export default component.exports